
import { getPartnerJoinStatusByIdOptions } from "@/services/queryOptions/partnerQueryOptions";
import { useQuery } from "@tanstack/react-query";
import usePartner from "./usePartner";
import { useAuthStore } from "./useAuthStore";

export default function usePartnerJoinStatus() {
    const { isAuthenticated } = useAuthStore();
    // Always call hooks in the same order to comply with Rules of Hooks
    const { data: partner } = usePartner();

    const query = useQuery({
        ...getPartnerJoinStatusByIdOptions(partner?.id),
        enabled: isAuthenticated && !!partner?.id,
    });

    if (!isAuthenticated) {
        return {
            ...query,
            data: { hasJoined: false },
        };
    }

    return query;
}
